import { useQuery } from "@tanstack/react-query";
import { storageApi, type StorageStatus } from "../lib/api";

const STORAGE_STATUS_QUERY_KEY = ["storage-status"];

/**
 * Hook to fetch and cache storage status
 * Refetches every 5 minutes to keep status up to date
 */
export function useStorageStatus() {
  return useQuery<StorageStatus>({
    queryKey: STORAGE_STATUS_QUERY_KEY,
    queryFn: () => storageApi.getStorageStatus(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
    refetchOnWindowFocus: true,
  });
}

/**
 * Helper to check if uploads should be blocked
 */
export function useUploadsBlocked(): boolean {
  const { data } = useStorageStatus();
  return data?.is_critical ?? false;
}

/**
 * Helper to check if storage warning should be shown
 */
export function useStorageWarning(): boolean {
  const { data } = useStorageStatus();
  return data?.is_warning ?? false;
}
